export default __webpack_public_path__ + "static/call-9f67e819001cd616ba13a1ffb615a1c9.png";